import GoogleMap from './GoogleMap.vue'

export default {
    'google-map': GoogleMap
}
